import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import { MEDIA_UPLOAD_PROGRESS_EVENT } from "../provider/data-provider";

const MediaUploadProgressOverlay = () => {
  const [state, setState] = React.useState({ active: false, percent: 0 });

  React.useEffect(() => {
    const listener = (event) => {
      const detail = event.detail || {};
      setState({
        active: Boolean(detail.active),
        percent: Number.isFinite(detail.percent) ? detail.percent : 0,
      });
    };

    window.addEventListener(MEDIA_UPLOAD_PROGRESS_EVENT, listener);
    return () => {
      window.removeEventListener(MEDIA_UPLOAD_PROGRESS_EVENT, listener);
    };
  }, []);

  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1000 })}
      open={state.active}
    >
      <Box
        sx={{
          width: "min(520px, 90vw)",
          backgroundColor: "white",
          color: "black",
          borderRadius: 1,
          p: 2,
          boxShadow: 4,
        }}
      >
        <Typography variant="subtitle1">Enviando mídias...</Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          {state.percent}%
        </Typography>
        <LinearProgress variant="determinate" value={state.percent} />
      </Box>
    </Backdrop>
  );
};

export default MediaUploadProgressOverlay;
